import './App.css';
import SupportApp from './SupportApp';

function App() {
  return (
    <div className="App">
      <SupportApp />
    </div>
  );
}

export default App;
